(function () {
  var MAX_CARDS = 36;
  var WHITE_DISTANCE = 80;
  var BAY_RED = 241;
  var BAY_GREEN = 243;
  var BAY_BLUE = 245;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }
    callback();
  }

  function isContentPixel(data, index) {
    var alpha = data[index + 3];
    if (alpha < 20) return false;

    var red = data[index];
    var green = data[index + 1];
    var blue = data[index + 2];
    return 765 - red - green - blue > WHITE_DISTANCE;
  }

  function trimCardMedia(media) {
    if (!media || media.dataset.hdTrimmed === 'true') return;

    var image = media.querySelector('img');
    if (!image) return;

    function process() {
      if (!image.naturalWidth || !image.naturalHeight) return;

      try {
        var sourceWidth = image.naturalWidth;
        var sourceHeight = image.naturalHeight;
        var canvas = document.createElement('canvas');
        canvas.width = sourceWidth;
        canvas.height = sourceHeight;

        var context = canvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(image, 0, 0, sourceWidth, sourceHeight);

        var pixels = context.getImageData(0, 0, sourceWidth, sourceHeight).data;
        var minX = sourceWidth;
        var minY = sourceHeight;
        var maxX = 0;
        var maxY = 0;
        var found = false;
        var step = sourceWidth > 600 ? 2 : 1;

        for (var y = 0; y < sourceHeight; y += step) {
          for (var x = 0; x < sourceWidth; x += step) {
            var index = (y * sourceWidth + x) * 4;
            if (!isContentPixel(pixels, index)) continue;
            found = true;
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
          }
        }

        if (!found) return;

        var padding = Math.max(24, Math.round(Math.max(maxX - minX, maxY - minY) * 0.16));
        minX = Math.max(0, minX - padding);
        minY = Math.max(0, minY - padding);
        maxX = Math.min(sourceWidth, maxX + padding);
        maxY = Math.min(sourceHeight, maxY + padding);

        var cropWidth = Math.max(1, maxX - minX);
        var cropHeight = Math.max(1, maxY - minY);
        var outputSize = 640;
        var output = document.createElement('canvas');
        output.width = outputSize;
        output.height = outputSize;

        var outputContext = output.getContext('2d');
        outputContext.fillStyle = '#f1f3f5';
        outputContext.fillRect(0, 0, outputSize, outputSize);

        var scale = Math.min((outputSize * 0.86) / cropWidth, (outputSize * 0.86) / cropHeight);
        var drawWidth = cropWidth * scale;
        var drawHeight = cropHeight * scale;
        var drawX = (outputSize - drawWidth) / 2;
        var drawY = (outputSize - drawHeight) / 2;

        outputContext.drawImage(canvas, minX, minY, cropWidth, cropHeight, drawX, drawY, drawWidth, drawHeight);

        var outputPixels = outputContext.getImageData(0, 0, outputSize, outputSize);
        var outputData = outputPixels.data;
        for (var pixelIndex = 0; pixelIndex < outputData.length; pixelIndex += 4) {
          var red = outputData[pixelIndex];
          var green = outputData[pixelIndex + 1];
          var blue = outputData[pixelIndex + 2];
          if (765 - red - green - blue <= WHITE_DISTANCE) {
            outputData[pixelIndex] = BAY_RED;
            outputData[pixelIndex + 1] = BAY_GREEN;
            outputData[pixelIndex + 2] = BAY_BLUE;
          }
        }
        outputContext.putImageData(outputPixels, 0, 0);

        var trimmedImage = output.toDataURL('image/jpeg', 0.88);
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = trimmedImage;
        media.style.backgroundImage = 'url("' + trimmedImage + '")';
        media.style.backgroundSize = 'contain';
        media.style.backgroundPosition = 'center';
        media.classList.add('hd-card-media--trimmed');
        media.dataset.hdTrimmed = 'true';
      } catch (error) {
        media.dataset.hdTrimmed = 'error';
      }
    }

    if (image.complete) {
      process();
      return;
    }

    image.addEventListener('load', process, { once: true });
  }

  function trimVisibleCards() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('.hd-card-media'), 0, MAX_CARDS);
    cards.forEach(trimCardMedia);
  }

  onReady(function () {
    trimVisibleCards();
    document.addEventListener('shopify:section:load', trimVisibleCards);

    var queued = false;
    var observer = new MutationObserver(function (mutations) {
      var hasCardMedia = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return false;
          return node.matches && (node.matches('.hd-card-media') || node.querySelector('.hd-card-media'));
        });
      });

      if (!hasCardMedia || queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        trimVisibleCards();
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
